<template>
    <frontend-layout>
        <div class="container pb-8 pt-24 text-center lg:pb-24">
            <div class="text-[28px] font-semibold md:text-[40px]">
                EMTprep vs. Medictests
            </div>
            <div class="leading-loose">
                If you’re just looking for practice problems, either platform
                should have you covered (with over 7,000 practice questions
                each). But let us show you some unique features you’ll find only
                on EMTprep.
            </div>
        </div>
        <div class="mx-auto hidden px-24 xl:block">
            <img
                class="mx-auto"
                src="/assets/art/comparison_student_dashboard_large.png"
            />
        </div>

        <div class="mx-auto hidden px-4 md:block xl:hidden">
            <img
                class="w-full"
                src="/assets/art/comparison_student_dashboard_medium.png"
            />
        </div>
        <div class="block w-full md:hidden">
            <img
                class="w-full"
                src="/assets/art/comparison_student_dashboard_small.png"
            />
        </div>

        <div class="bg-gray-900">
            <div class="container max-w-2xl py-24 text-white">
                <div class="">
                    <svg
                        width="54"
                        height="47"
                        viewBox="0 0 54 47"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.476 32.155C0.476 40.699 3.68 46.306 13.292 46.306C14.894 46.306 16.229 46.039 17.564 45.772C24.506 44.17 23.438 39.097 22.904 31.087C22.37 25.213 23.171 17.737 25.841 12.13C28.244 6.78999 23.438 0.648985 17.564 0.648985C5.282 0.648985 0.476 22.81 0.476 32.155ZM25.307 32.155C25.307 40.699 28.511 46.306 38.123 46.306C39.725 46.306 41.06 46.039 42.395 45.772C49.337 44.17 48.269 39.097 47.735 31.087C47.201 25.213 48.002 17.737 50.672 12.13C53.075 6.78999 48.269 0.648985 42.395 0.648985C30.113 0.648985 25.307 22.81 25.307 32.155Z"
                            fill="#FAB637"
                        />
                    </svg>
                </div>
                <div class="my-8 flex flex-col gap-4 text-[24px]">
                    <p>
                        The targeted quizzes, videos, and flashcards were so
                        useful to helping me review my weak areas.
                    </p>
                    <p>
                        I also attended multiple weekly livestreams to get my
                        questions answered.
                    </p>
                    <p>
                        EMTprep really calmed my nerves before going into the
                        NREMT exam. The whole platform is awesome.
                    </p>
                </div>
                <div class="mt-4 flex gap-4">
                    <div class="">
                        <img src="/assets/art/home_testimonial_portrait.png" />
                    </div>
                    <div class="text-[20px]">
                        <div class="">Eleanor Sanderson</div>
                        <div class="text-gray-500">EMT 2022</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mx-auto py-24 md:container">
            <div
                class="mx-auto max-w-2xl pb-12 text-center text-[28px] font-semibold lg:text-[40px]"
            >
                We’ve got everything you need to pass your exam
            </div>
            <table class="w-full border-collapse">
                <thead class="">
                    <th class="w-auto md:w-64"></th>
                    <th
                        class="w-16 border-x p-4 align-bottom md:w-auto lg:align-middle"
                    >
                        <img
                            class="mx-auto hidden lg:block"
                            src="/assets/art/comparison_emtprep_logo_horiz.png"
                        />
                        <img
                            class="mx-auto lg:hidden"
                            src="/assets/art/comparison_emtprep_logo_vert.png"
                        />
                    </th>

                    <th
                        class="w-16 border-x border-r-0 p-4 align-bottom md:w-auto lg:align-middle"
                    >
                        <img
                            class="mx-auto hidden lg:block"
                            src="/assets/art/comparison_medic_tests_logo_horiz.png"
                        />
                        <img
                            class="mx-auto lg:hidden"
                            src="/assets/art/comparison_medic_tests_logo_vert.png"
                        />
                    </th>
                </thead>
                <tbody>
                    <tr class="even:bg-gray-50">
                        <td class="border border-l-0 border-gray-200 p-4">
                            <div class="font-semibold">Practice questions</div>
                        </td>
                        <td class="border border-gray-200 p-4">
                            <img
                                class="mx-auto"
                                src="/assets/art/green_check_circle.png"
                            />
                        </td>

                        <td class="border border-r-0 border-gray-200 p-4">
                            <img
                                class="mx-auto"
                                src="/assets/art/green_check_circle.png"
                            />
                        </td>
                    </tr>
                    <tr class="even:bg-gray-50">
                        <td class="border border-l-0 border-gray-200 p-4">
                            <div class="font-semibold">
                                Works on all devices
                            </div>
                        </td>

                        <td class="border border-gray-200 p-4 text-center">
                            --
                        </td>
                        <td class="border border-r-0 border-gray-200 p-4">
                            <img
                                class="mx-auto"
                                src="/assets/art/green_check_circle.png"
                            />
                        </td>
                    </tr>
                    <tr class="even:bg-gray-50">
                        <td class="border border-l-0 border-gray-200 p-4">
                            <div class="font-semibold">Study Guides</div>
                        </td>
                        <td class="border border-gray-200 p-4">
                            <img
                                class="mx-auto"
                                src="/assets/art/green_check_circle.png"
                            />
                        </td>

                        <td
                            class="border border-r-0 border-gray-200 p-4 text-center"
                        >
                            --
                        </td>
                    </tr>
                    <tr class="even:bg-gray-50">
                        <td class="border border-l-0 border-gray-200 p-4">
                            <div class="">
                                <span
                                    class="rounded rounded-full bg-secondary-800 px-3 py-1 text-[16px] text-white"
                                    >New</span
                                >
                            </div>
                            <div class="font-semibold">Assessment Quiz</div>
                            <div class="text-gray-700">
                                Identify the areas you need to work on the first
                                time you login
                            </div>
                        </td>
                        <td class="border border-gray-200 p-4">
                            <img
                                class="mx-auto"
                                src="/assets/art/green_check_circle.png"
                            />
                        </td>

                        <td
                            class="border border-r-0 border-gray-200 p-4 text-center"
                        >
                            --
                        </td>
                    </tr>
                    <!--                    <tr class="even:bg-gray-50">-->
                    <!--                        <td class="border border-l-0 border-gray-200 p-4">-->
                    <!--                            <div class="font-semibold">Adaptive Simulation</div>-->
                    <!--                            <div class="text-gray-700">-->
                    <!--                                A practice test that closely mimics the NREMT-->
                    <!--                                exam-->
                    <!--                            </div>-->
                    <!--                        </td>-->
                    <!--                        <td class="border border-gray-200 p-4">-->
                    <!--                            <img-->
                    <!--                                class="mx-auto"-->
                    <!--                                src="/assets/art/green_check_circle.png"-->
                    <!--                            />-->
                    <!--                        </td>-->

                    <!--                        <td-->
                    <!--                            class="border border-r-0 border-gray-200 p-4 text-center"-->
                    <!--                        >-->
                    <!--                            &#45;&#45;-->
                    <!--                        </td>-->
                    <!--                    </tr>-->
                    <tr class="even:bg-gray-50">
                        <td class="border border-l-0 border-gray-200 p-4">
                            <div class="font-semibold">Video Lesson</div>
                            <div class="text-gray-700">
                                400+ hours of video lessons, lectures, &
                                animations
                            </div>
                        </td>
                        <td class="border border-gray-200 p-4">
                            <img
                                class="mx-auto"
                                src="/assets/art/green_check_circle.png"
                            />
                        </td>

                        <td
                            class="border border-r-0 border-gray-200 p-4 text-center"
                        >
                            --
                        </td>
                    </tr>
                    <tr class="even:bg-gray-50">
                        <td class="border border-l-0 border-gray-200 p-4">
                            <div class="font-semibold">Weekly Livestreams</div>
                            <div class="text-gray-700">
                                Live events covering EMS topics, test strategy,
                                and Q&A
                            </div>
                        </td>
                        <td class="border border-gray-200 p-4">
                            <img
                                class="mx-auto"
                                src="/assets/art/green_check_circle.png"
                            />
                        </td>

                        <td
                            class="border border-r-0 border-gray-200 p-4 text-center"
                        >
                            --
                        </td>
                    </tr>
                    <tr class="even:bg-gray-50">
                        <td
                            class="border border-b-0 border-l-0 border-gray-200 p-4"
                        >
                            <div class="font-semibold">Flashcards</div>
                            <div class="leading-loose text-gray-700">
                                Thousands of flashcards covering all NREMT
                                topics
                            </div>
                        </td>
                        <td class="border border-b-0 border-gray-200 p-4">
                            <img
                                class="mx-auto"
                                src="/assets/art/green_check_circle.png"
                            />
                        </td>

                        <td
                            class="border border-b-0 border-r-0 border-gray-200 p-4 text-center"
                        >
                            --
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="bg-gray-900 px-4 py-24 text-white lg:px-12">
            <div class="mx-auto max-w-5xl">
                <div class="flex flex-col gap-4 text-center">
                    <div
                        class="text-[28px] font-semibold text-white lg:text-[40px]"
                    >
                        Buying for your team?
                    </div>
                    <div class="">
                        Receive bulk discounts along with a dedicated dashboard
                        to manage your students
                    </div>
                </div>

                <div
                    class="grid grid-cols-1 gap-8 py-8 md:grid-cols-2 lg:gap-8 lg:py-24"
                >
                    <div class="flex max-w-xl flex-col justify-center gap-4">
                        <div>
                            <svg
                                width="50"
                                height="50"
                                viewBox="0 0 50 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="25" cy="25" r="25" fill="#FAB637" />
                                <path
                                    d="M25 15.832L15 20.4154L25 24.9987L35 20.4154L25 15.832Z"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M15 29.582L25 34.1654L35 29.582"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M15 25L25 29.5833L35 25"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <div class="text-[36px] font-semibold text-white">
                            Bulk Discounts
                        </div>
                        <div class="leading-loose">
                            You’ll save money by buying in bulk. And don’t
                            worry, you can keep your memberships inactive until
                            you’re ready to assign them.
                        </div>
                    </div>
                    <div class="mx-auto flex w-full items-center">
                        <gradient-table
                            :table-headers="[
                                '# of memberships',
                                'Bulk discount',
                            ]"
                            :table-rows="[
                                ['5-10 memberships', '10% discount'],
                                ['11-25 memberships', '20% discount'],
                                ['26-50 memberships', '30% discount'],
                                ['51 - 99 memberships', '40% discount'],
                                ['100 + memberships', '50% discount'],
                            ]"
                            :table-cell-css="['', 'text-gray-600']"
                            table-row-class="group-even:bg-gray-800/25"
                            :dark-mode="true"
                        />
                    </div>
                </div>
                <div
                    class="grid grid-cols-1 gap-8 py-8 md:grid-cols-2 lg:gap-20 lg:py-24"
                >
                    <div class="order-2 flex items-center lg:order-1">
                        <img src="/assets/art/group_set_goals_example.png" />
                    </div>
                    <div
                        class="order-1 flex flex-col justify-center gap-4 lg:order-2"
                    >
                        <div class="">
                            <svg
                                width="44"
                                height="44"
                                viewBox="0 0 44 44"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="22" cy="22" r="22" fill="#FAB637" />
                                <path
                                    d="M28 18C28 16.4087 27.3679 14.8826 26.2426 13.7574C25.1174 12.6321 23.5913 12 22 12C20.4087 12 18.8826 12.6321 17.7574 13.7574C16.6321 14.8826 16 16.4087 16 18C16 25 13 27 13 27H31C31 27 28 25 28 18Z"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M23.73 31C23.5542 31.3031 23.3019 31.5547 22.9982 31.7295C22.6946 31.9044 22.3504 31.9965 22 31.9965C21.6496 31.9965 21.3054 31.9044 21.0018 31.7295C20.6982 31.5547 20.4458 31.3031 20.27 31"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <div class="text-[36px] font-semibold text-white">
                            Set goals for your classrooms
                        </div>
                        <div class="leading-loose">
                            Monitor your students’ study habits and, and ensure
                            that they meet the study goals that you set for
                            them.
                        </div>
                    </div>
                </div>
                <div
                    class="grid grid-cols-1 gap-8 py-8 md:grid-cols-2 lg:gap-20 lg:py-24"
                >
                    <div class="flex flex-col justify-center gap-4">
                        <div class="">
                            <svg
                                width="44"
                                height="44"
                                viewBox="0 0 44 44"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="22" cy="22" r="22" fill="#FAB637" />
                                <path
                                    d="M22 28V18"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M28 28V12"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M16 28V24"
                                    stroke="white"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <div class="text-[36px] font-semibold text-white">
                            Track students’ progress
                        </div>
                        <div class="leading-loose">
                            Track scores, total study time, and achievements for
                            all your students — right on the dashboard.
                        </div>
                    </div>
                    <div class="flex items-center">
                        <img
                            src="/assets/art/group_track_students_example.png"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="container m-24 mx-auto max-w-4xl bg-gray-900 p-12">
            <frontend-pass-guarantee />
        </div>
    </frontend-layout>
</template>

<script>
import FrontendLayout from "@/_Layouts/FrontendLayout";
import GradientTable from "@/Components/GradientTable";
import FrontendPassGuarantee from "@/Pages/Frontend/FrontendPassGuarantee.vue";

export default {
    name: "CompetitorsLanding",
    components: {
        FrontendPassGuarantee,
        FrontendLayout,
        GradientTable,
    },
};
</script>

<style scoped></style>
